/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const account_in = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2 10.8h4.667M5.11 12.356 6.667 10.8m0 0L5.11 9.244M6.667 6.66l.08-.06h3.729c1.475 1.101 3.035 2.905 3.035 4.667 0 2.437-1.21 3.733-4.9 3.733-1.045 0-1.89-.104-2.567-.308M11.644 1l-5.6.933s.934.51.934 1.867h3.033c0-1.358 1.633-2.8 1.633-2.8Z"
    />
  </svg>
)
export default account_in
